import React from 'react';

import { Tag } from '@travel/ui';
import type { BADGE_COLOR } from '@travel/ui/components/Tag';
import { cx } from '@travel/utils';

import { Translate } from 'core/translate';

import styles from './providerBox.module.scss';

type Props = {
  availabilityCount: number;
  tagClassName?: string;
  color?: BADGE_COLOR;
};

function RoomUrgencyMessage({ availabilityCount, tagClassName, color = 'blue' }: Props) {
  return (
    <Tag
      color={color}
      type="filled"
      className={cx(styles.tag, tagClassName)}
      data-testid={`providerBox-roomUrgencyMessage`}
    >
      <Translate
        id="Provider_Info.Room_List.Plan_Info.Urgency_message"
        count={availabilityCount}
        data={{ number_of_rooms_available: availabilityCount }}
      />
    </Tag>
  );
}

export default RoomUrgencyMessage;
